import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

import {
  AppointmentReviewForm,
  Loading,
  useReviewCategories,
} from '@virtual-care/ui';

function AppointmentReview() {
  const { t } = useTranslation();
  const { reservationId, meetingId } = useParams<{
    reservationId: string;
    meetingId: string;
  }>();
  const navigate = useNavigate();

  const { questions: patientQuestions, isLoading } =
    useReviewCategories('patient');

  if (!meetingId || !reservationId) {
    return <div>{t('appointments.review.invalidParams')}</div>;
  }

  if (isLoading) return <Loading />;

  return (
    <AppointmentReviewForm
      meetingId={meetingId}
      reservationId={reservationId}
      questions={patientQuestions}
      onCancel={() => navigate('/')}
    />
  );
}

export default AppointmentReview;
